import styled from 'styled-components';

export const Box = styled.div`
  padding: 16px;
  border: 1px solid ${(props) => props.theme.colors['neutral-40']};
  border-radius: 8px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const TitleAndDateRow = styled(Row)`
  margin-bottom: 12px;
`;

export const Title = styled.p`
  font-size: 14px;
  line-height: 150%;
  font-weight: 600;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-right: 8px;
`;

export const Date = styled.p`
  font-size: 10px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const DataTitle = styled.p`
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-80']};
  margin-right: 6px;
`;

export const Link = styled.a`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${(props) => props.theme.colors['primary-60']};
  cursor: pointer;
  font-size: 14px;
  line-height: 150%;

  svg {
    font-size: 14px;
  }
`;

export const Video = styled.video`
  width: 100%;
  margin-top: 12px;
`;
